export const ADD_MESSAGE = "shute/addMessage";
export const SET_LISTENER_CONTEXT = 'shute/setListenerContext'
export const ADD_QUEUED_EVENT_LISTENER = "shute/addQueuedEventListener";
export const REMOVE_QUEUED_EVENT_LISTENER = "shute/removeQueuedEventListener";
export const ADD_PENDING_EVENT_LISTENER = "shute/addPendingEventListener";
export const REMOVE_PENDING_EVENT_LISTENER = "shute/removePendingEventListener";
export const ADD_TO_PREFSQUEUE = "prefs/addToQueue";

export const SET_VERSION = "shute/setVersion";
export const SET_SESSION = "shute/setSession";
